import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c4bf6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 静源健康管理责任有限公司", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-v-8e5d8606": "",
  target: "_blank",
  class: "out-link",
  href: "https://beian.miit.gov.cn/"
}, "蒙ICP备2024016192号", -1))

import { useUserStore } from '@/store/index'
import { onUnmounted, reactive } from 'vue'
import { useStaticImg } from '@/utils/static'

// const { redirct_url } = useRoute().query


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userStore = useUserStore()

const staticImg = useStaticImg()

const handleEnter = event => {
  if (event.key === 'Enter') login()
}

window.addEventListener('keypress', handleEnter)

const state = reactive({
  username: '',
  password: ''
})

const login = () => {
  userStore.login(state)
}

onUnmounted(() => {
  console.log('我是不是没触发')

  window.removeEventListener('keypress', handleEnter)
})


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, {
      style: {"width":"100vw","height":"100vh","overflow":"hidden"},
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 24,
          style: {"display":"flex","justify-content":"center","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [8, 8] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  class: "app-name",
                  span: 24,
                  style: {"display":"flex","justify-content":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      style: {"width":"86px","height":"86px","object-fit":"cover","margin-right":"20px"},
                      src: require('@/assets/logo.png'),
                      alt: ""
                    }, null, 8, _hoisted_1),
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  style: {"margin-top":"20px","display":"flex","justify-content":"center"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      name: "basic",
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 16 },
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "手机号",
                          name: "username",
                          rules: [{ required: true, message: '请填写账号' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              style: {"width":"328px","height":"42px"},
                              value: state.username,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.username) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "密码",
                          name: "password",
                          rules: [{ required: true, message: '请输入密码' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_password, {
                              style: {"width":"328px","height":"42px"},
                              value: state.password,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.password) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "",
                          style: {"display":"flex","justify-content":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              onClick: login,
                              style: {"width":"200px"},
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("登录")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3
  ], 64))
}
}

})